import { FC, useState } from 'react';
import { Button, Form, Item } from 'tedooo-web-design-system/ui';
import { ArrowRight } from 'tedooo-web-design-system/icons';

import { PhoneInput } from 'components/phoneInput';

export interface IGetTheAppPhoneForm {
  onPhoneSubmit(input: { phone: string }): void;
  errorMessage?: string;
  validateStatus?: 'error';
}

const GetTheAppPhoneForm: FC<IGetTheAppPhoneForm> = ({ onPhoneSubmit, errorMessage }) => {
  const [phoneNumber, setPhoneNumber] = useState('');

  const onChange = (number: string) => setPhoneNumber(number);

  const validateStatus = errorMessage ? 'error' : undefined;

  const isDisabled = phoneNumber === '';

  return (
    <Form onFinish={onPhoneSubmit} className="form">
      <Item help={errorMessage} name="phone" validateStatus={validateStatus}>
        <div className="phone-input">
          <PhoneInput phoneNumber={phoneNumber} onChange={onChange} isError={false} />
        </div>
      </Item>
      <Button
        size="large"
        type="primary"
        borderRadius="large"
        prefixIcon={<ArrowRight className="send-arrow" />}
        className="send-button"
        disabled={isDisabled}
      />
    </Form>
  );
};

export default GetTheAppPhoneForm;
